import { useState } from 'react';
import { useParams } from 'react-router-dom';

import { DataGrid } from '@/components';
import { useDataGridColumns } from '@/components/DataGrid/hooks/useDataGridCols';
import {
  DataGridColSettings,
  mergeColumnSettings,
} from '@/components/DataGrid/utils';
import { LocalStoragePrefix } from '@/constants';
import { useBuildingInspectionContext } from '@/pages/Tools/BuildingInspection/BuildingInspectionContext';
import { violationsDataGridCols } from '@/pages/Tools/BuildingInspection/dummy_data/dummy_violations';
import { useUserStore } from '@/store';
import { getLocalStorageItem } from '@/utils';

export const ViolationsDataGrid = () => {
  const { user } = useUserStore();

  const { inspectionId } = useParams();
  const [columnSettings, setColumnSettings] = useState<DataGridColSettings[]>(
    () => {
      const savedSettings = getLocalStorageItem({
        key: String(user?._id),
        prefix: `Violations-list-${LocalStoragePrefix.TableSetting}`,
        shouldParse: true,
      });

      if (!savedSettings) {
        return violationsDataGridCols;
      }

      return mergeColumnSettings(violationsDataGridCols, savedSettings);
    },
  );
  const { violations, updateViolation, setViolations } =
    useBuildingInspectionContext();

  const columns = useDataGridColumns({
    type: 'inspectionViolationsCols',
    actionMethods: {
      onDelete: (e: string) =>
        setViolations((prevViolations) =>
          prevViolations.filter((v) => v._id !== e),
        ),

      onStatusChanged: (e: { _id: string; isCorrected: any }) =>
        updateViolation(e._id, { isCorrected: !e.isCorrected }),
      onEdit: (e: any) => e,
    },
    columnSettings,
  }).map((column) => ({
    ...column,
    renderCell: (params: any) => {
      return column.renderCell ? column.renderCell(params) : params.value;
    },
  }));

  const fetchBuildingViolations = () => {
    return Promise.resolve({
      rows: violations.filter((item) => item.inspection_id === inspectionId),
    });
  };
  return (
    <DataGrid
      hideFilter
      hideFooterPagination
      hideFooter
      key="inspectionViolationsCols"
      name="violations-list"
      columnSettings={columnSettings}
      setColumnSettings={setColumnSettings}
      columns={columns}
      disableMultipleColumnsSorting={true}
      fetchData={fetchBuildingViolations}
      disableRowSelectionOnClick
      autoPageSize={false}
      rows={violations.filter((item) => item.inspection_id === inspectionId)}
      sx={{ maxHeight: '300px' }}
      slots={{ toolbar: null }}
    />
  );
};
